// import { uiSchema as ui } from "../static/dynamicForm/ui-schema";
import * as turf from "@turf/turf";
import { getName } from "../components/util";
import { unitsEnum } from "./const";

const schema = {
  title:
    "Create a grid of a requested shape (squares, hexagons, points, or triangles).",
  type: "object",
  properties: {
    cellLength: {
      type: "integer",
      title: "Length of cell"
    },
    shape: {
      type: "string",
      title: "Shapes of the grid cells",
      enum: ["squares", "hexes", "points", "triangles"]
    },
    lengthUnit: {
      type: "string",
      title: "Unit of length",
      enum: unitsEnum.enum
    }
  }
};

const initial = { cellLength: 10, lengthUnit: "kilometers", shape: "squares" };

const createGrid = (shape, bb, cellLength, lengthUnit) => {
  switch (shape) {
    case "squares":
      return turf.squareGrid(bb, cellLength, {
        units: lengthUnit.toLocaleLowerCase()
      });
    case "hexes":
      return turf.hexGrid(bb, cellLength, {
        units: lengthUnit.toLocaleLowerCase()
      });
    case "points":
      return turf.pointGrid(bb, cellLength, {
        units: lengthUnit.toLocaleLowerCase()
      });
    case "triangles":
      return turf.triangleGrid(bb, cellLength, {
        units: lengthUnit.toLocaleLowerCase()
      });
    default:
      return null;
  }
};

const fn = props => {
  const { formData, layer, addLayer, handleClose } = props;
  const { lengthUnit, shape, cellLength } = formData;
  const bb = turf.bbox(layer);

  const grids = createGrid(shape, bb, cellLength, lengthUnit);

  addLayer({
    layer: grids,
    name: `${shape} grid of ${getName(layer)}`
  });
  handleClose();
};

export const gridForm = { initial: initial, ui: {}, schema, fn };
